<template>
	<div>
		<div class="flex w-full space-x-4 main">
			<BaseInput
				ref="BaseInput.unchecked_wmi.0"
				:placeholder="$t('wmi')"
				v-model="manufacturer.wmi"
				class="w-1/3"
				mask="BBB"
				:required="manufacturer.name"
			/>
			<BaseInput
				ref="BaseInput.unchecked_name.0"
				:placeholder="$t('name')"
				v-model="manufacturer.name"
				class="w-full"
				mask="CXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
				:required="manufacturer.wmi"
			/>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import Validate from '@/mixins/Validate';
import VehicleManufacturerRepository from '@/api/repositories/VehicleManufacturerRepository';

export default {
	name: 'VehicleManufacturer',
	components: { BaseInput },
	mixins: [Validate],
	data() {
		return {
			manufacturer: {
				id: null,
				name: null,
				wmi: null,
			},
		};
	},
	computed: {
		isNew() {
			return this.$route.name === 'vehicles.manufacturer.new';
		},
	},
	mounted() {
		if (!this.isNew) {
			VehicleManufacturerRepository.show(this.$route.params.id).then(response => {
				this.manufacturer = response.data.data;
			});
		}
	},
	methods: {
		save() {
			if (this.validate()) {
				return this.updateInsert();
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
		updateInsert() {
			if (this.isNew) {
				this.manufacturer.checked = true;
				return VehicleManufacturerRepository.store(this.manufacturer).then(response => {
					this.manufacturer = response.data.data;
					this.$store.commit('setConfirmLeaving', false);
					return this.$swal(this.$t('general.success').toString(), this.$t('manufacturer_stored').toString(), 'success').then(() =>
						this.$router.replace({ name: 'vehicles.manufacturer.id', params: { id: this.manufacturer.id } }),
					);
				});
			} else {
				return VehicleManufacturerRepository.update(this.manufacturer.id, this.manufacturer).then(() => {
					this.$store.commit('setConfirmLeaving', false);
					return this.$swal(this.$t('general.success').toString(), this.$t('manufacturer_saved').toString(), 'success');
				});
			}
		},
	},
};
</script>

<style scoped></style>
